import styled from "styled-components/macro";

import FnrIcon from "UI/FnrIcon";
import { colors } from "UI/colors";

export const Border = styled.div`
  border: 1px solid ${colors.fnGray300};
  padding: ${(props) => {
    if (typeof props.padding === "number")
      return props.padding ? `${props.padding}px` : "10px";
    return props.padding || "10px";
  }};
  border-radius: 10px;
  ${(props) => props.pointer && `cursor: pointer;`}
  background: #FFF;
  box-shadow: rgba(0, 0, 0, 0.1) 0 1px 4px;
`;

export const FlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${(props) => props.gap || 0};
`;

export const Stack = styled.div`
  > * + * {
    margin-top: ${({ gap }) => {
      if (typeof gap === "number") return `${gap}px`;
      if (typeof gap === "string" && gap.includes("px")) return gap;

      return "36px";
    }};
  }
`;

export const IconSection = styled.div`
  display: flex;
`;
export const IconSectionContent = styled.div``;
export const IconSectionTitle = styled.div`
  min-height: 28px;
  display: flex;
  align-items: center;
`;

export const IconSectionIcon = (props) => {
  return (
    <IconWrapper>
      <FnrIcon {...props} />
    </IconWrapper>
  );
};
const IconWrapper = styled.div`
  font-size: 22px;
  width: 28px;
  height: 28px;
  text-align: center;
  flex-shrink: 0;
  margin-right: 14px;
`;
